import React, { useContext, useEffect, useState } from "react";
import { Button, Col, DatePicker, Form, message, Row, Select } from "antd";
import moment from "moment";
import planningService from "@services/planning.service";
import performanceManagementService from "@services/performanceManagement.service";
import { DynamicChartContext } from ".";

// import atollService from "@services/atoll.services";

const { RangePicker } = DatePicker;

/* eslint-disable no-template-curly-in-string */
const validateMessages = {
  required: "${label} is required!",
};
/* eslint-enable no-template-curly-in-string */

function disabledMaxDate(current) {
  const d = moment();
  if (d) return d.isBefore(current);
  return false;
}

const technologies = [
  // { label: "All", value: "all", subregion: "" },
  { label: "2G", value: "2G", subregion: "GSM_SUBREGION" },
  { label: "3G", value: "3G", subregion: "UMTS_SUBREGION" },
  { label: "4G", value: "4G", subregion: "LMBB_SUBREGION" },
  // { label: "FDD", value: "FDD", subregion: "LMBB_SUBREGION" },
  // { label: "TDD", value: "TDD", subregion: "LFBB_SUBREGION" },
];

const Filter = () => {
  const { setLoading, loading, setDataSource } =
    useContext(DynamicChartContext);

  const [regions, setRegions] = useState({
    loading: false,
    data: [],
    error: null,
  });
  const [subRegions, setSubRegions] = useState({
    loading: false,
    data: [],
    error: null,
  });
  const [cities, setCities] = useState({
    loading: false,
    data: [],
    error: null,
  });
  const [kpis, setKpis] = useState({ loading: false, data: [], error: null });
  const [provinces, setProvinces] = useState({
    loading: false,
    data: [],
    error: null,
  });

  const [form] = Form.useForm();

  async function fetchRegions() {
    setRegions({ ...regions, loading: true });

    try {
      const res = await planningService.fetchRegions();

      setRegions({
        ...regions,
        loading: false,
        data: [
          ...res.data.map((r) => ({
            label: r,
            value: r,
          })),
        ],
      });
    } catch (error) {
      console.log(error);
      setRegions({ ...regions, loading: false, error: error });
    }
  }

  async function fetchSubRegions(id) {
    setSubRegions({ ...subRegions, loading: true });

    try {
      const res = await planningService.fetchSubRegions(id);

      setSubRegions({
        ...subRegions,
        loading: false,
        data: [
          ...res.data.map((r) => ({
            label: r,
            value: r,
          })),
        ],
      });
    } catch (error) {
      console.log(error);
      setSubRegions({ ...subRegions, loading: false, error: error });
    }
  }

  async function fetchCities() {
    setCities({ ...cities, loading: true });

    try {
      const res = await planningService.fetchCities();
      setCities({
        ...cities,
        loading: false,
        data: [...res.data.map((c) => ({ label: c, value: c }))],
      });
    } catch (error) {
      console.log(error);
      setCities({ ...cities, loading: false, error: error });
    }
  }

  async function fetchProvinces() {
    setProvinces({ ...provinces, loading: true });
    try {
      const res = await planningService.fetchProvinces();
      setProvinces({
        ...provinces,
        loading: false,
        data: [
          ...res.data.map((p) => ({
            label: p,
            value: p,
          })),
        ],
      });
    } catch (error) {
      console.log(error);
      setProvinces({ ...provinces, loading: false, error: error });
    }
  }

  async function fetchKpis() {
    setKpis({ ...kpis, loading: true });

    try {
      // const res = await atollService.fetchKpis();
      setKpis({
        ...kpis,
        loading: false,
        data: [
          "4G_THR",
          "4G_CSSR_PS",
          "3G_THR",
          "3G_DCR_CS",
          "3G_CSSR_CS",
          "2G_DCR",
          "2G_CSSR",
        ].map((s) => ({ label: s, value: s })),
      });
    } catch (error) {
      console.log(error);
      setKpis({ ...kpis, loading: false, error: error });
    }
  }

  function fetchDatas() {
    fetchRegions();
    fetchCities();
    fetchProvinces();
    fetchKpis();
  }

  useEffect(() => {
    fetchDatas();
  }, []);

  const fetcher = async (params) => {
    setLoading(true);
    try {
      const { data } = await performanceManagementService.fetchP1P2Dynamic(
        params
      );

      setDataSource(data);
    } catch (error) {
      message.error("Action has error",20);
    } finally {
      setLoading(false);
    }
  };

  const onFinish = async ({ datetime, ...values }) => {
    try {
      const startTime = moment(
        datetime && datetime.length > 0 ? datetime[0] : new Date()
      )
        .hours(0)
        .minutes(0)
        .seconds(0)
        .valueOf();

      const endTime = moment(
        datetime && datetime.length > 1 ? datetime[1] : new Date()
      )
        .hours(23)
        .minutes(59)
        .seconds(59)
        .valueOf();

      fetcher({ ...values, datetime: [startTime, endTime] });
    } catch (err) {
      console.log(err);
    }
  };

  const handleFormValuesChange = async (changedValues) => {
    const formFieldName = Object.keys(changedValues)[0];
    if (formFieldName === "technology") {
      // form.setFieldsValue({ subregion: [{ label: "All", value: "all" }] });
      form.setFieldsValue({ subregion: [] });

      const tech = technologies.find(
        (x) => x.value === changedValues.technology
      );
      if (tech) fetchSubRegions(tech.subregion || "");
      else fetchSubRegions("");
    }
  };

  useEffect(() => {
    fetchSubRegions("LMBB_SUBREGION");
    form.submit();
  }, []);

  return (
    <>
      <Form
        form={form}
        layout="vertical"
        name="nest-messages"
        onFinish={onFinish}
        onValuesChange={handleFormValuesChange}
        validateMessages={validateMessages}
        initialValues={{
          technology: "4G",
          priority: ["P1", "P2"],
          region: ["R1", "R8", "R3"],
          subregion: [],
          province: [],
          kpi: [],
          park_status: [0, 1],
          datetime: [
            moment().subtract(2, "week").hours(0).minutes(0).seconds(0),
            moment().hours(23).minutes(59).seconds(59),
          ],
        }}
      >
        <Row gutter={[14, 0]}>
          <Col xs={24} sm={24} md={12} lg={8} xl={6} xxl={4}>
            <Form.Item
              name="technology"
              label="Technology"
              rules={[
                {
                  // type: "array",
                  // required: true,
                },
              ]}
            >
              <Select
                // mode="multiple"
                allowClear
                showSearch
                style={{ width: "100%" }}
                placeholder="Please select"
                options={[...technologies]}
              />
            </Form.Item>
          </Col>
          <Col xs={24} sm={24} md={12} lg={8} xl={6} xxl={4}>
            <Form.Item
              name="priority"
              label="Priority"
              rules={[
                {
                  type: "array",
                  // required: true,
                },
              ]}
            >
              <Select
                mode="multiple"
                allowClear
                showSearch
                style={{ width: "100%" }}
                placeholder="Please select"
                // maxTagCount={5}
                options={[
                  // { label: "All", value: "all" },
                  { label: "P1", value: "P1" },
                  { label: "P2", value: "P2" },
                ]}
              />
            </Form.Item>
          </Col>
          <Col xs={24} sm={24} md={12} lg={8} xl={6} xxl={4}>
            <Form.Item
              name="region"
              label="Region"
              rules={[
                {
                  type: "array",
                  // required: true,
                },
              ]}
            >
              <Select
                mode="multiple"
                allowClear
                showSearch
                style={{ width: "100%" }}
                placeholder="Please select"
                // maxTagCount={5}
                // options={[{ label: "All", value: "all" }, ...regions.data]}
                options={[...regions.data]}
              />
            </Form.Item>
          </Col>
          <Col xs={24} sm={24} md={12} lg={8} xl={6} xxl={4}>
            <Form.Item
              name="subregion"
              label="Subregion"
              rules={[
                {
                  type: "array",
                  // required: true,
                },
              ]}
            >
              <Select
                mode="multiple"
                allowClear
                showSearch
                style={{ width: "100%" }}
                placeholder="Please select"
                // maxTagCount={5}
                // options={[{ label: "All", value: "all" }, ...subRegions.data]}
                options={[...subRegions.data]}
              />
            </Form.Item>
          </Col>
          <Col xs={24} sm={24} md={12} lg={8} xl={6} xxl={4}>
            <Form.Item
              name="province"
              label="Province"
              rules={[
                {
                  type: "array",
                  // required: true,
                },
              ]}
            >
              <Select
                mode="multiple"
                allowClear
                showSearch
                style={{ width: "100%" }}
                placeholder="Please select"
                // maxTagCount={5}
                // options={[{ label: "All", value: "all" }, ...provinces.data]}
                options={[...provinces.data]}
              />
            </Form.Item>
          </Col>
          <Col xs={24} sm={24} md={12} lg={8} xl={6} xxl={4}>
            <Form.Item
              name="kpi"
              label="KPI"
              rules={[
                {
                  type: "array",
                  // required: true,
                },
              ]}
            >
              <Select
                mode="multiple"
                allowClear
                showSearch
                style={{ width: "100%" }}
                placeholder="Please select"
                // maxTagCount={5}
                // options={[{ label: "All", value: "all" }, ...kpis.data]}
                options={[...kpis.data]}
              />
            </Form.Item>
          </Col>
          <Col xs={24} sm={24} md={12} lg={12} xl={6} xxl={5}>
            <Form.Item
              name="park_status"
              label="Park Status"
              rules={[
                {
                  type: "array",
                  // required: true,
                },
              ]}
            >
              <Select
                mode="multiple"
                allowClear
                showSearch
                style={{ width: "100%" }}
                placeholder="Please select"
                // maxTagCount={5}
                options={[
                  { label: "Not Parked", value: 0 },
                  { label: "Parked", value: 1 },
                ]}
              />
            </Form.Item>
          </Col>
          <Col xs={24} sm={24} md={12} lg={12} xl={6} xxl={5}>
            <Form.Item
              name="datetime"
              label="Datetime"
              // rules={[
              //   {
              //     // type: "array",
              //     // required: true,
              //   },
              // ]}
            >
              <RangePicker
                format="YYYY-MM-DD"
                className="w-full"
                showTime={false}
                disabledDate={disabledMaxDate}
              />
            </Form.Item>
          </Col>

          <Col flex="auto" className="flex justify-end items-end">
            <Form.Item>
              <div className="space-x-2">
                <Button
                  type="primary"
                  htmlType="submit"
                  disabled={loading}
                  className="mt-4"
                >
                  View
                </Button>
                <Button
                  onClick={() => {
                    form.resetFields();
                  }}
                >
                  Clear
                </Button>
              </div>
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </>
  );
};

export default Filter;
